import { Room } from 'src/app/model/room/room';

export class RoomError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'RoomError';
  }

  static ThrowIfNull(room: Room | undefined | null): void {
    if (!room) {
      throw new RoomError('Room must exist to initialise this component or service');
    }
  }
}
